import React        from 'react';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import { BaseNotification } from './BaseNotification';

export default function BiometriaNotification({ notification, onDismiss }) {
  return (
    <BaseNotification
      notification={notification}
      onDismiss={onDismiss}
      icon={<FingerprintIcon style={{ fontSize: 18 }} />}
    />
  );
}
